<img class="gwa-credit-card__brand-icon"
	[src]="'assets/payment.icons/' + cardIcon()" />
<form [formGroup]="ccForm" class="gwa-credit-card">
	<div class="gwc-form__field-group gwc-form__field-group--row">
		<mat-form-field class="gwc-form__field gwc-form__field--grow">
			<mat-label>Name on Card</mat-label>
			<input formControlName="name"
				matInput>
			<mat-error>Please enter the credit card holder's name</mat-error>
		</mat-form-field>
	</div>
	<div class="gwc-form__field-group gwc-form__field-group--row">
		<mat-form-field class="gwc-form__field gwc-form__field--grow">
			<mat-label>Credit Card Number</mat-label>
			<input formControlName="number"
				matInput
				ccNumber
				id="cc-number"
				type="tel"
				(input)="getCreditCardIcon()">
			@if (ccForm.controls['number'].hasError('required')) {
				<mat-error>Please enter the credit card number</mat-error>
			} @else if (ccForm.controls['number'].hasError('ccNumber')) {
				<mat-error>Please enter a valid credit card number</mat-error>
			}
		</mat-form-field>
		<mat-form-field class="gwc-form__field gwc-form__field--small">
			<mat-label>CVC/CVV</mat-label>
			<input matInput
				formControlName="cvc"
				type="tel"
				mask="000||0000"
				ccCVC>
			@if (ccForm.controls['cvc'].hasError('required')) {
				<mat-error>Required</mat-error>
			} @else if (ccForm.controls['cvc'].hasError('minLength') || ccForm.controls['cvc'].hasError('maxLength')) {
				<mat-error>Invalid security code</mat-error>
			}
		</mat-form-field>
	</div>
	<div class="gwc-form__field-group gwc-form__field-group--row">
		<mat-form-field class="gwc-form__field gwc-form__field--grow">
			<mat-label>Exp. Month</mat-label>
			<mat-select formControlName="month"
				gwaExpirationMonthValidator>
				@for (month of expirationMonths; track month) {
					<mat-option [value]="month">
						{{ month }}
					</mat-option>
				}
			</mat-select>
			@if (ccForm.controls['month'].hasError('required')) {
				<mat-error>Required</mat-error>
			} @else if (ccForm.controls['month'].hasError('expiration')) {
				<mat-error>Must be in the future</mat-error>
			}
		</mat-form-field>
		<mat-form-field class="gwc-form__field gwc-form__field--grow">
			<mat-label>Exp. Year</mat-label>
			<mat-select formControlName="year">
				@for (year of expirationYears(); track year) {
					<mat-option [value]="year">
						{{ year }}
					</mat-option>
				}
			</mat-select>
			@if (ccForm.controls['year'].hasError('required')) {
				<mat-error>Required</mat-error>
			} @else if (ccForm.controls['year'].hasError('expiration')) {
				<mat-error>Must be in the future</mat-error>
			}
		</mat-form-field>
		<mat-form-field class="gwc-form__field gwc-form__field--grow">
			<mat-label>Billing ZIP Code</mat-label>
			<input matInput
				type="tel"
				mask="00000"
				formControlName="zip">
			@if (ccForm.controls['zip'].hasError('required')) {
				<mat-error>Required</mat-error>
			} @else if (ccForm.controls['zip'].hasError('pattern')) {
				<mat-error>Invalid</mat-error>
			}
		</mat-form-field>
	</div>
</form>